import {
  MdOutlineHome,
  MdOutlineWorkOutline,
  MdOutlineStarBorder,
  MdOutlineCandlestickChart,
  MdOutlineDriveFileRenameOutline,
  MdOutlineLeaderboard,
  MdOutlineEmojiEvents,
  MdOutlineBalance,
  MdOutlineTrendingUp,
  MdOutlineSchool,
  MdOutlineSettings,
  MdOutlinePayments,
} from "react-icons/md";
import { SUBSCRIPTION_ENABLED } from "../utils/utils";

// Single, consistent Material Symbols (outline) icon family across the whole
// sidebar. Each item carries an `Icon` component rendered with a shared size /
// stroke so nothing looks mismatched.

// Primary product nav — DESKTOP ONLY. On mobile these live in the bottom
// navigation bar (Feed / Portfolio / Add / Watchlist / Chart), so the 3-dot
// menu omits them to avoid duplicating the same destinations.
export const mainNav = [
  { label: "Home", path: "/feed", Icon: MdOutlineHome },
  {
    label: "Portfolio",
    path: "/portfolio",
    Icon: MdOutlineWorkOutline,
    guideId: "profile-guide-menu-portfolio",
  },
  {
    label: "Watchlist",
    path: "/search",
    Icon: MdOutlineStarBorder,
    guideId: "profile-guide-menu-watchlist",
  },
  { label: "Trade", path: "/charts", Icon: MdOutlineCandlestickChart },
];

// Standalone action pill (desktop only — "Add" lives in the mobile bottom bar).
export const createPostItem = {
  label: "Create Post",
  path: "/create-post",
  Icon: MdOutlineDriveFileRenameOutline,
};

// Secondary nav — shown on BOTH desktop and mobile, grouped into sections.
export const secondaryNav = [
  {
    title: "Compete",
    items: [
      { label: "Leaderboard", path: "/leaderboard", Icon: MdOutlineLeaderboard },
      { label: "League Play", path: "/contest", Icon: MdOutlineEmojiEvents },
    ],
  },
  {
    title: "Market Pulse",
    items: [
      {
        label: "Market Sentiment",
        path: "/market-sentiment",
        Icon: MdOutlineBalance,
      },
      {
        label: "Today’s Movers",
        path: "/auth/trending-stocks",
        Icon: MdOutlineTrendingUp,
      },
    ],
  },
  {
    title: "Learn",
    items: [{ label: "The Edge", path: "/trading-floor", Icon: MdOutlineSchool }],
  },
];

// Account section — Settings sits here near the bottom, separated from the
// product nav. Subscriptions is appended only when the feature flag is on.
export const accountSection = {
  title: "Account",
  items: [{ label: "Settings", path: "/settings", Icon: MdOutlineSettings }],
};

if (SUBSCRIPTION_ENABLED) {
  accountSection.items.push({
    label: "Subscriptions",
    path: "/subscriptions",
    Icon: MdOutlinePayments,
  });
}

// Flattened list kept as the default export for backward compatibility.
const initMenu = [
  ...mainNav,
  createPostItem,
  ...secondaryNav.flatMap((section) => section.items),
  ...accountSection.items,
];

export default initMenu;
